import { render, staticRenderFns } from "./wordsInput.vue?vue&type=template&id=32e33e3c&scoped=true"
import script from "./wordsInput.vue?vue&type=script&lang=js"
export * from "./wordsInput.vue?vue&type=script&lang=js"
import style0 from "./wordsInput.vue?vue&type=style&index=0&id=32e33e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e33e3c",
  null
  
)

export default component.exports